import { CoinApiWrapper } from '@xylabs/sdk-coin-js'
import { ApiStage } from '@xyo-network/sdk-xyo-js'
import React from 'react'

interface ApiContextProps {
  api?: CoinApiWrapper
  apiDomain?: string
  apiStage?: ApiStage
  error?: Error
  refreshAll?: () => void
}

const ApiContext = React.createContext<ApiContextProps>({})
export default ApiContext
